<template>
  <div class="row">
    <div class="label">
      <p>图片</p>
      <p>视频</p>
    </div>
    <div class="box">
      <slot></slot>
    </div>
    <el-button-group class="ml10">
      <el-tooltip
        class="item"
        effect="dark"
        content="上移"
        placement="bottom-start"
      >
        <el-button
          type="text"
          @click="handleSortPrev"
          round
          size="mini"
          :disabled="index === 0"
          icon="el-icon-caret-top"
        ></el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="下移" placement="bottom">
        <el-button
          type="text"
          @click="handleSortNext"
          round
          size="mini"
          :disabled="index === len - 1"
          icon="el-icon-caret-bottom"
        ></el-button>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="删除"
        placement="bottom-right"
      >
        <el-button
          type="text"
          @click="handleDelete"
          round
          size="mini"
          icon="el-icon-delete"
        ></el-button>
      </el-tooltip>
    </el-button-group>
  </div>
</template>

<script>
export default {
  props: {
    index: Number,
    len: Number,
  },
  methods: {
    handleSortPrev() {
      this.$emit("on-prev", this.index);
    },
    handleSortNext() {
      this.$emit("on-next", this.index);
    },
    handleDelete() {
      this.$emit("on-delete", this.index);
    },
  },
};
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10px;
}
.row {
  display: flex;
  align-items: flex-start;
}
.label {
  width: 50px;
  font-size: 14px;
  margin-right: 5px;
  color: #333;
}
.box {
  flex: 1;
  padding: 20px;
  border: 1px solid #ebebeb;
  border-radius: 8px;
}
</style>